import React from 'react';

const hospitalDropHeadings = [
  { name: 'Drop Address', key: 1 },
  { name: 'Updated By', key: 2 },
  { name: 'Updated At', key: 3 },
];

const getEmergencyDropsTemplate = (drop) => {
  return {
    1: {
      title: drop.address_line,
    },
    2: {
      title: drop.updated_by,
    },
    3: {
      title: drop.updated_at,
    },
  };
};

const getEmergencyDropsRows = (drops) => {
  const rowsData = [];
  drops &&
    drops.map((drop) => {
      const dropObj = getEmergencyDropsTemplate(drop);
      rowsData.push(dropObj);
      return true;
    });
  return rowsData;
};

export const getDrops = (drops) => {
  return {
    headings: hospitalDropHeadings,
    rows: getEmergencyDropsRows(drops),
  };
};
